<!--
 * @Descripttion: 修改了一些内容
 * @version: v1.0
 * @Author: htt
 * @Date: 2021-09-24 17:29:17
 * @LastEditors: htt
 * @LastEditTime: 2021-12-09 14:49:25
-->
<template>
  <el-dialog
    :title="!dataForm.id ? '新增' : '修改'+'机位'"
    :close-on-click-modal="false"
    :before-close="handleClose"
    :visible.sync="visible"
    width="720px"
    height="456px"
    class="info-dialog"
  >
    <el-form
      ref="dataForm"
      label-position="right"
      label-width="120px"
      :model="dataForm"
      :rules="rules"
    >
      <el-form-item prop="fieldId" label="场地室名称：">
        <el-select v-model="dataForm.fieldId" placeholder="请选择场地室名称" @change="filedSelectHandle">
          <el-option
            v-for="item in getBidList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item prop="seatName" label="机位名称：">
        <el-input
          v-model.trim="dataForm.seatName"
          placeholder="请输入机位名称"
          maxlength="30"
          clearable
        />
      </el-form-item>
      <el-form-item prop="seatCode" label="机位编码：">
        <el-input
          v-model.trim="dataForm.seatCode"
          placeholder="请输入机位编码"
          clearable
          maxlength="30"
        />
      </el-form-item>
      <el-form-item prop="seatMac" label="机位物理地址：">
        <el-input
          v-model.trim="dataForm.seatMac"
          placeholder="请输入机位编码"
          clearable
          maxlength="36"
        />
      </el-form-item>
      <!--  0启用 1停用 -->
      <el-form-item prop="seatStatus" label="是否启用：">
        <el-switch
          v-model="dataForm.seatStatus"
          :active-value="0"
          :inactive-value="1"
          active-color="#2568EC"
          inactive-color="#F23030"
        />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button v-preventReClick type="primary" @click="dataFormSubmit()">提交</el-button>
    </span>
  </el-dialog>
</template>

<script>
import {
  infoMaintainSelect,
  infoSeatDetail,
  infoSeatSave
} from '@/server/field'
export default {
  data(vm) {
    return {
      visible: false,
      getBidList: [],
      dataForm: {
        id: '',
        fieldId: '',
        tradeOrgId: '',
        fieldName: '',
        fieldFloor: '',
        seatName: '',
        seatCode: '',
        seatMac: '',
        seatStatus: 0
      },
      rules: {
        fieldId: [
          { required: true, message: '请选择场地室名称', trigger: ['blur','change'] }
        ],
        seatName: [
          { required: true, message: '请填写机位名称', trigger: 'blur' }
        ],
        seatCode: [
          { required: true, message: '请填写机位编码', trigger: 'blur' }
        ],
        seatMac: [
          { required: true, message: '请填写机位物理地址', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    handleClose() {
      this.visible = false
    },
    filedSelectHandle(val) {
      const index = this.getBidList.findIndex(mitem => mitem.id === val)
      if (index > -1) {
        this.dataForm.fieldName = this.getBidList[index].name
        this.dataForm.fieldFloor = this.getBidList[index].fieldFloor
      } else {
        this.dataForm.fieldName = ''
        this.dataForm.fieldFloor = ''
      }
    },
    getBid(tradeOrgId) {
      infoMaintainSelect(tradeOrgId).then(res => {
        if (res.data.code === '1') {
          this.getBidList = res.data.data || []
        }
      })
    },
    init(id, tradeOrgId,fieldFloor) {
      this.visible = true
      this.dataForm.id = id || ''
      this.dataForm.tradeOrgId = tradeOrgId
      this.dataForm.fieldFloor = fieldFloor
      this.$nextTick(() => {
        this.getBid(tradeOrgId)
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          infoSeatDetail(id).then(res => {
            if (res.data.code === '1') {
              this.dataForm = res.data.data ? res.data.data : {}
            } else {
              this.$message.error(res.data.msg)
            }
          })
        }
      })
    },
    // 表单提交
    dataFormSubmit() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          infoSeatSave(this.dataForm).then(res => {
            if (res.data.code === '1') {
              this.$message.success(res.data.msg)
              this.visible = false
              this.$emit('refreshDataList')
            } else {
              this.$message.error(res.data.msg)
              this.visible = false
            }
          })
        }
      })
    }
  }
}
</script>
